<template>
  <v-autocomplete
    v-model="selected"
    :items="members"
    :label="label"
    no-data-text="Nenhum membro encontrado"
    :loading="loading"
    :rules="rules"
    outlined
    dense
    item-text="name"
    item-value="id"
    return-object
    hide-details="auto"
  >
    <template v-slot:item="{ item }">
      <div class="d-flex flex-column py-1">
        <b>{{ item.name }}</b>
        <span class="text-caption">{{ item.phone }}</span>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import BaseSelector from "./BaseSelector.vue";
import MEMBERS from "@/services/admin/members";

export default {
  components: { BaseSelector },
  props: {
    value: {
      type: Object | null,
      required: true,
    },
    label: {
      type: String,
      default: "Selecione um membro",
    },
    permission: {
      type: Number | Array | null,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      members: [],
    };
  },
  methods: {
    async loadMembers() {
      try {
        this.loading = true;
        var response = await MEMBERS.getAll();
        this.members = response.users.map((u) => ({
          ...u,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    hasPermission(permissions, permission) {
      if (Array.isArray(permission))
        return permission.some((p) => (permissions & p) == p);
      return (permissions & permission) == permission;
    },
  },
  computed: {
    filteredMembers() {
      if (!this.permission) return this.members;
      return this.members.filter((m) =>
        this.hasPermission(m.permissions, this.permission)
      );
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    this.loadMembers();
  },
};
</script>
